import { render, staticRenderFns } from "./PsiDetail.vue?vue&type=template&id=a56fcc12"
import script from "./PsiDetail.vue?vue&type=script&lang=js"
export * from "./PsiDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports